(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) module.exports = engine;
  else root.PlaybackCatalogEngine = engine;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var WORDS = {
    boots: 'boot', shoes: 'shoe', sneakers: 'sneaker', sticks: 'stick',
    helmets: 'helmet', headguards: 'headgear', headguard: 'headgear',
    pads: 'pad', bags: 'bag', backpacks: 'backpack', putters: 'putter',
    wedges: 'wedge', racquets: 'racquet', rackets: 'racquet', racket: 'racquet',
    paddles: 'paddle', hoppers: 'hopper', collectors: 'collector', baskets: 'basket',
    tanks: 'tank', jackets: 'jacket', vests: 'vest', hats: 'hat', socks: 'sock',
    skins: 'skin', snowshoes: 'snowshoe', wetsuits: 'wetsuit', braces: 'brace',
    coolers: 'cooler', strollers: 'stroller', slacklines: 'slackline',
    womens: 'women', woman: 'women', wmn: 'women', wmns: 'women', wm: 'women',
    mens: 'men', man: 'men', kids: 'child', children: 'child',
    small: 's', medium: 'm', large: 'l', xsmall: 'xs', xlarge: 'xl',
    mondo: 'mondopoint', inch: 'inches', in: 'inches', foot: 'feet', ft: 'feet',
    degree: 'degrees', centimetres: 'cm', centimeters: 'cm', millimeters: 'mm'
  };
  var EQUIPMENT = [
    ['ski-boots', ['ski boot', 'alpine boot', 'downhill boot']],
    ['toddler-shoes', ['toddler shoe', 'toddler sneaker', 'skate shoe', 'child shoe']],
    ['complete-sticks', ['lacrosse stick', 'lacrosse']],
    ['soft-padded-headgear', ['soft shell helmet', 'soft shell headgear', 'padded headgear', 'headgear', 'helmet']],
    ['knee-pads', ['knee pad', 'skate pad']],
    ['ankle-braces', ['ankle brace', 'ankle support']],
    ['snowshoes', ['snowshoe']], ['ski-skins', ['ski skin']],
    ['sand-wedges', ['sand wedge', 'golf wedge', 'wedge']],
    ['putters', ['golf putter', 'putter']],
    ['table-tennis-paddle-sets', ['table tennis paddle', 'table tennis']],
    ['ball-hoppers-collectors', ['ball hopper', 'ball collector', 'ball basket', 'ball pick up']],
    ['bags-backpacks', ['tennis bag', 'racquet bag', 'pickleball bag', 'pickleball backpack', 'pickleball duffel']],
    ['training-aids', ['tennis trainer', 'tennis training aid', 'eye coach']],
    ['ski-socks', ['ski sock']], ['snow-pants', ['snow pants']],
    ['rain-hats', ['rain hat']], ['tops', ['tank top', 'tank with bra', 'racerback tank']],
    ['leggings', ['leggings']], ['wetsuits', ['wetsuit']],
    ['slacklines', ['slackline']], ['coolers', ['cooler']],
    ['backpack-strap-pads', ['shoulder pad', 'backpack strap pad']],
    ['jogging-strollers', ['jogging stroller', 'jogger']],
    ['yoga-trainers', ['headstand bench', 'headstand trainer', 'inversion bench']]
  ];

  function list(value) {
    if (value === null || value === undefined || value === '') return [];
    return Array.isArray(value) ? value : [value];
  }
  function id(value) { return String(value === undefined || value === null ? '' : value).split('/').pop(); }
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[’']/g, '').replace(/\bsoft(?:shell| shelled)\b/g, 'soft shell')
      .replace(/\bsnow shoes?\b/g, 'snowshoe').replace(/\bwet suits?\b/g, 'wetsuit')
      .replace(/\bkneepads?\b/g, 'knee pad').replace(/\bping pong\b/g, 'table tennis')
      .replace(/\bduffle\b/g, 'duffel').replace(/\blax\b/g, 'lacrosse')
      .replace(/(\d)\s*x\s*(?=\d)/g, '$1 x ')
      .replace(/(\d)(cm|mm|ft|inches|inch|in)\b/g, '$1 $2')
      .replace(/(\d)\s*["″]/g, '$1 inches').replace(/(\d)\s*°/g, '$1 degrees')
      .replace(/[^a-z0-9.]+/g, ' ').replace(/\.(?!\d)|(?<!\d)\./g, ' ')
      .split(/\s+/).filter(Boolean).map(function (word) { return WORDS[word] || word; }).join(' ');
  }
  function phrase(text, needle) { return (' ' + text + ' ').indexOf(' ' + normalize(needle) + ' ') !== -1; }
  function withoutNumbers(text) { return text.replace(/\b\d+(?:\.\d+)?\b/g, ' ').replace(/\s+/g, ' ').trim(); }
  function numbers(text) {
    return (text.match(/\b\d+(?:\.\d+)?\b/g) || []).map(Number);
  }
  function sameValues(a, b) {
    return JSON.stringify(list(a).map(String).sort()) === JSON.stringify(list(b).map(String).sort());
  }
  function optionsSignature(options) {
    return list(options).map(function (option) {
      return String(option.name || '') + ':' + list(option.values).map(String).sort().join('|');
    }).sort().join('\n');
  }
  function eligibleVariant(variant) {
    return variant.available === true && Boolean(variant.inventory_management)
      && Number(variant.inventory_quantity) > 0 && String(variant.inventory_policy).toLowerCase() === 'deny';
  }
  function withAvailableVariant(live, variant) {
    var price = Number(variant.price);
    return Object.assign({}, live, {
      price: Number.isFinite(price) ? price : live.price,
      price_formatted: variant.price_formatted || (price === Number(live.price) ? live.price_formatted : null),
      available_variant_id: id(variant.id)
    });
  }
  function unclassified(live, reasons) {
    return Object.assign({}, live, {
      product_id: id(live.id || live.product_id), source_title: live.title || '', category_id: 'unclassified',
      category_label: 'More available gear', equipment_id: 'unclassified',
      equipment_label: 'Check listing', hub_ids: [], brand: { label: null, status: 'not_listed' },
      condition: { label: null, filter_value: null, status: 'confirm' },
      size: { family_id: null, family: null, label: null, filter_value: null,
        normalized_value: null, normalized_system: null, age_groups: [], genders: [], status: 'not_listed' },
      specs: [], search: { aliases: [], model_values: [], source_title: live.title || '' },
      needs_review: true, review_flags: reasons, available: true
    });
  }
  function intersectLive(manifest, liveProducts) {
    var known = new Map(list(manifest.products).map(function (product) { return [id(product.product_id), product]; }));
    return list(liveProducts).reduce(function (result, live) {
      var record = known.get(id(live.id || live.product_id));
      var available = list(live.variants).filter(eligibleVariant).slice().sort(function (a, b) { return Number(a.price) - Number(b.price); });
      if (!available.length) return result;
      if (!record) { result.push(unclassified(withAvailableVariant(live, available[0]), ['Product not in reviewed catalog'])); return result; }
      var matchedVariant = available.find(function (variant) { return id(variant.id) === id(record.variant_id); });
      if (!matchedVariant) {
        result.push(unclassified(withAvailableVariant(live, available[0]), ['Available variant differs from reviewed variant']));
        return result;
      }
      var drift = [];
      if (String(live.title || '').trim() !== String(record.source_title || '').trim()) drift.push('Source title changed');
      if (record.source_options && optionsSignature(record.source_options) !== optionsSignature(live.options)) drift.push('Source options changed');
      if (record.source_tags && !sameValues(record.source_tags, live.tags)) drift.push('Source tags changed');
      result.push(drift.length ? unclassified(withAvailableVariant(live, available[0]), drift) : Object.assign({}, record, withAvailableVariant(live, matchedVariant), {
        product_id: id(record.product_id), available: true, needs_review: false
      }));
      return result;
    }, []);
  }

  function absentEquipment(text) {
    var accessory = /\b(bag|backpack|duffel|collector|hopper|basket|trainer|training|pad|shoe|skin|sock|pant|jacket)\b/.test(text);
    if (phrase(text, 'tackle') && phrase(text, 'helmet')) return true;
    if (phrase(text, 'hard shell') && phrase(text, 'helmet')) return true;
    if (phrase(text, 'pickleball paddle')) return true;
    if (phrase(text, 'tennis racquet') && !/\b(bag|backpack)\b/.test(text)) return true;
    if (/\b(hockey|ice skate|snowboard|cleat|kayak|bicycle|bike)\b/.test(text)) return true;
    if (/\bskis\b/.test(text) && !accessory) return true;
    if (phrase(text, 'tennis ball') && !/\b(collector|hopper|basket|trainer|training|bag)\b/.test(text)) return true;
    return false;
  }
  function analyzeQuery(query) {
    var text = normalize(query);
    var equipment = EQUIPMENT.filter(function (entry) {
      return entry[1].some(function (term) { return phrase(text, term); });
    }).map(function (entry) { return entry[0]; });
    if (equipment.indexOf('table-tennis-paddle-sets') !== -1) equipment = ['table-tennis-paddle-sets'];
    return { original: String(query || ''), text: text, equipment_ids: equipment,
      absent_equipment: absentEquipment(text), numeric_values: numbers(text) };
  }
  function reviewedSpecs(product) {
    return list(product.specs).filter(function (spec) { return spec.status === 'as_listed' && spec.filter_value !== null; });
  }
  function modelNumbers(product, text) {
    var candidates = list(product.search && product.search.model_values);
    var brand = product.brand && product.brand.status === 'as_listed' ? normalize(product.brand.label) : '';
    candidates = candidates.concat(list(product.search && product.search.aliases).filter(function (alias) {
      var normalized = normalize(alias);
      return brand && normalized.indexOf(brand + ' ') === 0 && numbers(normalized).length;
    }));
    return candidates.reduce(function (result, model) {
      var normalized = normalize(model);
      if (phrase(text, normalized) && (withoutNumbers(normalized) || (brand && phrase(text, brand)))) {
        result = result.concat(numbers(normalized));
      }
      return result;
    }, []);
  }
  function sizeQualifiers(product, text) {
    var size = product.size || {};
    if (/\b(women|men)\b/.test(text)) {
      var gender = phrase(text, 'women') ? 'women' : 'men';
      if (list(size.genders).indexOf(gender) === -1) return false;
    }
    for (var group of ['adult', 'youth', 'toddler']) {
      if (phrase(text, group) && list(size.age_groups).indexOf(group) === -1) return false;
    }
    for (var system of ['us', 'uk', 'eu', 'mondopoint']) {
      if (phrase(text, system) && normalize(size.normalized_system) !== system) return false;
    }
    if (phrase(text, 'clothing') && size.family_id !== 'clothing') return false;
    return true;
  }
  function matchesSize(product, text, value) {
    var size = product.size || {};
    var normalized = normalize(String(value));
    var stored = normalize(size.normalized_value);
    var numeric = /^\d+(?:\.\d+)?$/;
    var equal = numeric.test(normalized) && numeric.test(stored) ? Number(normalized) === Number(stored) : normalized === stored;
    return size.status === 'listed' && size.filter_value !== null
      && equal && sizeQualifiers(product, text);
  }
  function specKeys(text, product) {
    if (phrase(text, 'shaft')) return ['shaft_length'];
    if (phrase(text, 'total') || (phrase(text, 'complete') && phrase(text, 'length'))) return ['complete_stick_length'];
    if (phrase(text, 'width')) return ['skin_width', 'shoe_width'];
    if (phrase(text, 'bounce')) return ['golf_bounce'];
    if (phrase(text, 'loft') || (phrase(text, 'degrees') && product.category_id === 'golf')) return ['golf_loft'];
    if (phrase(text, 'flex') && product.equipment_id === 'ski-boots') return ['boot_flex'];
    if (phrase(text, 'footprint') || phrase(text, 'dimensions') || /\b\d+(?:\.\d+)?\s*x\s*\d/.test(text)) return ['snowshoe_footprint'];
    if (phrase(text, 'capacity') || phrase(text, 'cans') || phrase(text, 'balls')) return ['cooler_capacity', 'ball_capacity'];
    if (phrase(text, 'length')) return ['shaft_length', 'complete_stick_length', 'skin_length_range', 'slackline_length'];
    if (product.equipment_id === 'ski-skins') return ['skin_length_range'];
    if (product.equipment_id === 'sand-wedges') return ['golf_loft'];
    if (product.equipment_id === 'complete-sticks') return ['shaft_length', 'complete_stick_length'];
    if (product.equipment_id === 'slacklines') return ['slackline_length'];
    return [];
  }
  function matchSpec(product, text, values, keys) {
    return reviewedSpecs(product).some(function (spec) {
      if (keys.length && keys.indexOf(spec.key) === -1) return false;
      var unit = /\b(inches|feet|cm|mm|degrees)\b/.exec(text);
      if (unit && normalize(spec.unit) !== unit[1]) return false;
      if (values.length === 2 && spec.numeric_range) {
        return values[0] === spec.numeric_range.minimum && values[1] === spec.numeric_range.maximum;
      }
      if (values.length === 2 && spec.dimensions) return values[0] === spec.dimensions[0] && values[1] === spec.dimensions[1];
      return values.length === 1 && spec.numeric_value !== null && spec.numeric_value !== undefined && Number(spec.numeric_value) === values[0];
    });
  }
  function searchScore(product, parsed) {
    var text = parsed.text;
    if (!text) return 0;
    if (parsed.absent_equipment) return -1;
    if (parsed.equipment_ids.length && parsed.equipment_ids.indexOf(product.equipment_id) === -1) return -1;
    var condition = product.condition || {};
    var conditionIntent = phrase(text, 'like new') ? 'like_new' :
      (phrase(text, 'pre owned') || phrase(text, 'preowned') || phrase(text, 'used')) ? 'preowned' :
      (phrase(text, 'new') && !phrase(text, 'new balance')) ? 'new' :
      phrase(text, 'fair') ? 'fair' : phrase(text, 'good') ? 'good' : null;
    if (conditionIntent && (condition.status !== 'as_listed' ||
      (conditionIntent === 'preowned' ? ['used', 'good', 'fair', 'like_new'].indexOf(condition.filter_value) === -1 : condition.filter_value !== conditionIntent))) return -1;
    var size = product.size || {};
    var explicitSize = phrase(text, 'size') || phrase(text, 'mondopoint');
    var numeric = parsed.numeric_values.slice();
    var explicitSpec = /\b(length|width|loft|bounce|capacity|footprint|dimensions)\b/.test(text);
    var namedSize = /\b(?:size|mondopoint)\s+(?:(?:us|uk|eu|adult|youth|toddler|women|men)\s+)*(\d+(?:\.\d+)?|xs|s|m|l|xl|xxl)\b/.exec(text);
    var models = modelNumbers(product, text);
    numeric = Array.from(text.matchAll(/\b\d+(?:\.\d+)?\b/g)).filter(function (match) {
      var before = text.slice(0, match.index);
      var after = text.slice(match.index + match[0].length);
      var constrained = /\b(size|mondopoint|length|width|loft|bounce|capacity|flex|footprint|dimensions)\s+(?:(?:us|uk|eu|adult|youth|toddler|women|men|approximately|about)\s+)*$/.test(before)
        || /^\s*(inches|feet|cm|mm|degrees|balls|cans)\b/.test(after);
      if (phrase(before, 'flex') && !explicitSize && !explicitSpec && product.equipment_id !== 'ski-boots') constrained = false;
      return constrained || models.indexOf(Number(match[0])) === -1;
    }).map(function (match) { return Number(match[0]); });
    var letter = /\b(xs|s|m|l|xl|xxl)\b/.exec(text);
    var sizeIntent = explicitSize || Boolean(letter);
    if (namedSize) {
      if (!matchesSize(product, text, namedSize[1])) return -1;
      var fitIndex = numeric.indexOf(Number(namedSize[1]));
      if (fitIndex !== -1) numeric.splice(fitIndex, 1);
    } else if (sizeIntent && (numeric.length || letter)) {
      if (numeric.length > 1 || !matchesSize(product, text, numeric.length ? numeric[0] : letter[1])) return -1;
      numeric = [];
    }
    if (numeric.length) {
      var keys = specKeys(text, product);
      if (keys.length || explicitSpec) {
        if (!matchSpec(product, text, numeric, keys)) return -1;
      } else if (!(numeric.length === 1 && matchesSize(product, text, numeric[0])) && !matchSpec(product, text, numeric, [])) return -1;
    } else if (explicitSpec && !reviewedSpecs(product).some(function (spec) { return specKeys(text, product).indexOf(spec.key) !== -1; })) return -1;
    if (size.family_id && !sizeQualifiers(product, text) && /\b(women|men|adult|youth|toddler|us|uk|eu|mondopoint|clothing)\b/.test(text)) return -1;
    var fields = [product.source_title, product.title]
      .concat(list(product.hub_ids).map(function (hub) { return hub.replace(/-/g, ' '); }))
      .concat(list(product.search && product.search.aliases), list(product.search && product.search.model_values));
    if (!parsed.equipment_ids.length) fields.push(product.category_label);
    if (product.brand && product.brand.status === 'as_listed') fields.push(product.brand.label);
    if (product.condition && product.condition.status === 'as_listed') fields.push(product.condition.label);
    if (size.status === 'listed') fields.push(size.filter_value);
    reviewedSpecs(product).forEach(function (spec) { fields.push(spec.label, spec.value); });
    var haystack = normalize(fields.filter(Boolean).join(' '));
    var constraintWords = /^(size|length|shaft|total|complete|width|loft|bounce|capacity|footprint|dimensions|approximately|adult|youth|toddler|women|men|us|uk|eu|mondopoint|xs|s|m|l|xl|xxl|inches|feet|cm|mm|degrees|x|condition|new|used|pre|owned|preowned|like|fair|good)$/;
    var tokens = withoutNumbers(text).split(' ').filter(function (word) {
      if (!size.family_id && /^(adult|youth|toddler|women|men|us|uk|eu|mondopoint)$/.test(word)) return true;
      return word && !constraintWords.test(word);
    });
    if (!tokens.every(function (token) { return phrase(haystack, token); })) return -1;
    var score = tokens.length;
    if (phrase(normalize(product.source_title || product.title), text)) score += 10;
    if (list(product.search && product.search.aliases).some(function (alias) { return normalize(alias) === text; })) score += 20;
    return score;
  }
  function selected(value, candidate) {
    var choices = list(value).map(normalize);
    return !choices.length || choices.indexOf(normalize(candidate)) !== -1;
  }
  var queryVocabularies = new WeakMap();
  var protectedQueryWord = /^(size|length|shaft|total|complete|width|loft|bounce|capacity|footprint|dimensions|approximately|adult|youth|toddler|women|men|us|uk|eu|mondopoint|xs|s|m|l|xl|xxl|inches|feet|cm|mm|degrees|x|condition|new|used|pre|owned|preowned|like|fair|good|clothing|flex|hockey|skate|snowboard|cleat|kayak|bicycle|bike|skis|tackle|hard|shell)$/;
  function queryVocabulary(products) {
    if (queryVocabularies.has(products)) return queryVocabularies.get(products);
    var known = new Set(), candidates = new Set();
    list(products).forEach(function (product) {
      var aliases = list(product.search && product.search.aliases);
      var labels = [product.category_label, product.equipment_label];
      if (product.brand && product.brand.status === 'as_listed') labels.push(product.brand.label);
      var fields = labels.concat(aliases, [product.source_title, product.title], list(product.search && product.search.model_values));
      normalize(fields.filter(Boolean).join(' ')).split(' ').forEach(function (word) { known.add(word); });
      if (product.needs_review) return;
      labels.concat(aliases.filter(function (alias) { return !/\d/.test(alias); })).forEach(function (field) {
        normalize(field).split(' ').forEach(function (word) {
          if (/^[a-z]{5,}$/.test(word) && !protectedQueryWord.test(word)) candidates.add(word);
        });
      });
    });
    var vocabulary = { known: known, candidates: Array.from(candidates) };
    queryVocabularies.set(products, vocabulary);
    return vocabulary;
  }
  function oneLetterApart(left, right) {
    if (Math.abs(left.length - right.length) > 1) return false;
    var offset = 0;
    while (offset < Math.min(left.length, right.length) && left[offset] === right[offset]) offset += 1;
    if (left.length === right.length) {
      if (left.slice(offset + 1) === right.slice(offset + 1)) return true;
      return left[offset] === right[offset + 1] && left[offset + 1] === right[offset]
        && left.slice(offset + 2) === right.slice(offset + 2);
    }
    var shorter = left.length < right.length ? left : right;
    var longer = left.length < right.length ? right : left;
    return shorter.slice(offset) === longer.slice(offset + 1);
  }
  function resolveQuery(products, query) {
    var parsed = analyzeQuery(query);
    if (!parsed.text || list(products).some(function (product) { return searchScore(product, parsed) >= 0; })) return parsed;
    var vocabulary = queryVocabulary(products), corrections = [];
    var words = parsed.text.split(' ').map(function (word, position, tokens) {
      if (!/^[a-z]{4,}$/.test(word) || protectedQueryWord.test(word) || vocabulary.known.has(word)) return word;
      var nearby = vocabulary.candidates.filter(function (candidate) {
        return word.length >= 5 && oneLetterApart(word, candidate);
      });
      if (!nearby.length && position === tokens.length - 1) nearby = vocabulary.candidates.filter(function (candidate) {
        return candidate.indexOf(word) === 0;
      });
      if (nearby.length !== 1) return word;
      corrections.push({ from: word, to: nearby[0] });
      return nearby[0];
    });
    if (!corrections.length) return parsed;
    var resolved = analyzeQuery(words.join(' '));
    resolved.original = parsed.original;
    resolved.corrections = corrections;
    return resolved;
  }
  function filterProducts(products, filters) {
    filters = filters || {};
    products = list(products);
    var parsed = resolveQuery(products, filters.query || '');
    var matches = list(products).map(function (product, position) {
      var size = product.size || {}, brand = product.brand || {}, condition = product.condition || {};
      if (!selected(filters.category_id || filters.category, product.category_id)) return null;
      if (!selected(filters.equipment_id || filters.equipment, product.equipment_id)) return null;
      var hub = list(filters.hub_id || filters.hub);
      if (hub.length && !hub.some(function (value) { return list(product.hub_ids).indexOf(value) !== -1; })) return null;
      if (list(filters.brand).length && (brand.status !== 'as_listed' || !selected(filters.brand, brand.label))) return null;
      if (list(filters.condition).length && (condition.status !== 'as_listed' || !selected(filters.condition, condition.filter_value))) return null;
      if (list(filters.size_family).length && !selected(filters.size_family, size.family_id)) return null;
      if (list(filters.size).length && (size.status !== 'listed' || !selected(filters.size, size.filter_value))) return null;
      if (filters.size_status === 'check-listing' && ['confirm', 'not_listed'].indexOf(size.status) === -1) return null;
      if (filters.size_status && filters.size_status !== 'check-listing' && !selected(filters.size_status, size.status)) return null;
      for (var key of ['min_price', 'max_price']) {
        if (filters[key] !== '' && filters[key] !== undefined && filters[key] !== null) {
          var price = Number(product.price), boundary = Number(filters[key]);
          if (!Number.isFinite(price) || !Number.isFinite(boundary)) return null;
          if (key === 'min_price' ? price < boundary : price > boundary) return null;
        }
      }
      if (filters.specs && !Object.keys(filters.specs).every(function (key) {
        return reviewedSpecs(product).some(function (spec) { return spec.key === key && selected(filters.specs[key], spec.filter_value); });
      })) return null;
      var score = searchScore(product, parsed);
      return score < 0 ? null : { product: product, score: score, position: position };
    }).filter(Boolean);
    var sort = filters.sort || (parsed.text ? 'relevance' : 'original');
    matches.sort(function (a, b) {
      var order = 0;
      if (sort === 'relevance') order = b.score - a.score;
      if (sort === 'newest' || sort === 'created-descending') order = Number(b.product.created_at || 0) - Number(a.product.created_at || 0);
      if (sort === 'price-ascending' || sort === 'price-asc') order = Number(a.product.price) - Number(b.product.price);
      if (sort === 'price-descending' || sort === 'price-desc') order = Number(b.product.price) - Number(a.product.price);
      if (sort === 'title-ascending') order = String(a.product.title || a.product.source_title).localeCompare(String(b.product.title || b.product.source_title));
      return order || a.position - b.position;
    });
    return matches.map(function (match) { return match.product; });
  }
  function countValues(products, getValues) {
    var counts = new Map();
    products.forEach(function (product) {
      list(getValues(product)).filter(Boolean).forEach(function (value) {
        var key = typeof value === 'string' ? value : value.value;
        if (!counts.has(key)) counts.set(key, Object.assign({ value: key, label: key, count: 0 }, typeof value === 'string' ? {} : value));
        counts.get(key).count += 1;
      });
    });
    return Array.from(counts.values()).sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true }); });
  }
  function facets(products, filters) {
    var items = filterProducts(products, filters);
    return {
      total: items.length,
      categories: countValues(items, function (p) { return { value: p.category_id, label: p.category_label }; }),
      equipment: countValues(items, function (p) { return { value: p.equipment_id, label: p.equipment_label, category_id: p.category_id }; }),
      hubs: countValues(items, function (p) { return p.hub_ids; }),
      brands: countValues(items, function (p) { return p.brand && p.brand.status === 'as_listed' ? p.brand.label : null; }),
      conditions: countValues(items, function (p) { return p.condition && p.condition.status === 'as_listed' ? { value: p.condition.filter_value, label: p.condition.label } : null; }),
      sizes: countValues(items, function (p) { return p.size && p.size.status === 'listed' ? { value: p.size.filter_value, label: p.size.filter_value, family_id: p.size.family_id } : null; }),
      size_statuses: countValues(items, function (p) { return p.size && p.size.family_id && ['not_listed', 'confirm'].indexOf(p.size.status) !== -1 ? { value: 'check-listing', label: 'Check listing for size' } : null; })
    };
  }
  function counts(products) {
    var result = { total: list(products).length, categories: {}, equipment: {}, hubs: {} };
    list(products).forEach(function (product) {
      for (var pair of [['categories', product.category_id], ['equipment', product.equipment_id]]) {
        if (pair[1]) result[pair[0]][pair[1]] = (result[pair[0]][pair[1]] || 0) + 1;
      }
      list(product.hub_ids).forEach(function (hub) { result.hubs[hub] = (result.hubs[hub] || 0) + 1; });
    });
    return result;
  }
  function create(manifest) {
    return {
      intersectLive: function (liveProducts) { return intersectLive(manifest, liveProducts); },
      filter: filterProducts,
      search: function (products, query) { return filterProducts(products, { query: query }); },
      facets: facets, counts: counts, analyzeQuery: analyzeQuery
    };
  }
  return Object.freeze({ create: create, normalize: normalize, analyzeQuery: analyzeQuery,
    intersectLive: intersectLive, filterProducts: filterProducts,
    search: function (products, query) { return filterProducts(products, { query: query }); },
    facets: facets, counts: counts });
}));
